import React, { Component } from 'react';
import ClienteCard from './ClienteCard';

class SecondStep extends Component {
  constructor(props) {
    super(props);

    let pedidosSeleccionados = [];
    let facturacion = [];
    let propietario = [];
    let usuario = [];
    const pedidos = [];
    let todoCard = { facturacion: 'si', propietario: 'si', usuario: 'si' };
    if (this.props.init) {
      this.props.pedidosSeleccionados.forEach((pedido) => {
        pedido.codClie = this.props.clienteId;
        pedido.desClie = this.props.clienteName;
        pedido.codPropietarioVeh = this.props.clienteId;
        pedido.desPropietarioVeh = this.props.clienteName;
        pedido.codUsuarioVeh = this.props.clienteId;
        pedido.desUsuarioVeh = this.props.clienteName;
        pedidosSeleccionados.push(pedido);
        pedidos.push(pedido.numPedidoVeh);
      });
      facturacion = [{ id: this.props.clienteId, nombre: this.props.clienteName, pedidos }];
      propietario = [{ id: this.props.clienteId, nombre: this.props.clienteName, pedidos }];
      usuario = [{ id: this.props.clienteId, nombre: this.props.clienteName, pedidos }];
    } else {
      pedidosSeleccionados = this.props.pedidosFinal;
      facturacion = this.props.facturacion;
      propietario = this.props.propietario;
      usuario = this.props.usuario;
      todoCard = this.props.todoCard;
    }

    this.state = {
      pedidosFinal: pedidosSeleccionados,
      facturacion,
      propietario,
      usuario,
      todoCard,
    };
  }

  onChangeCheck = (e, tipoCliente) => {
    const { todoCard } = this.state;
    todoCard[tipoCliente] = e.target.value;
    this.setState({ todoCard });
  }

  addTipoCliente = (tipoCliente) => {
    const tipo = this.state[tipoCliente];
    tipo.push({ id: '', nombre: '', pedidos: [] });
    this.setState({ [tipoCliente]: tipo });
  }

  removeCard = (index, tipoCliente) => {
    const tipo = this.state[tipoCliente];
    tipo.splice(index, 1);
    this.setState({ [tipoCliente]: tipo });
  }

  selectClient = (cliente, tipoCliente, index) => {
    const { pedidosFinal } = this.state;
    const tipo = this.state[tipoCliente];
    tipo[index].nombre = cliente.nombre;
    tipo[index].id = cliente.codigo;

    pedidosFinal.filter(({ numPedidoVeh }) => tipo[index].pedidos.indexOf(numPedidoVeh)>=0)
                .forEach((pedido) => {
                  if (tipoCliente === 'facturacion') {
                    pedido.codClie = cliente.codigo;
                    pedido.desClie = cliente.nombre;
                  } else if (tipoCliente === 'propietario') {
                    pedido.codPropietarioVeh = cliente.codigo;
                    pedido.desPropietarioVeh = cliente.nombre;
                  } else if (tipoCliente === 'usuario') {
                    pedido.codUsuarioVeh = cliente.codigo;
                    pedido.desUsuarioVeh = cliente.nombre;
                  }
                });

    this.setState({ [tipoCliente]: tipo, pedidosFinal });
  }

  selectPedido = (pedido, tipoCliente, index) => {
    const tipo = this.state[tipoCliente];
    const { pedidos } = tipo[index];
    if (pedidos.indexOf(pedido)>=0) {
      tipo[index].pedidos = tipo[index].pedidos.filter(it => it !== pedido);
    } else {
      tipo.forEach((t, i) => {
        if (tipo[i].pedidos.indexOf(pedido)>=0) {
          tipo[i].pedidos = tipo[i].pedidos.filter(it => it !== pedido);
        }
      });
      tipo[index].pedidos.push(pedido);
    }
    this.setState({ [tipoCliente]: [...tipo] });
  }

  unselectPedido = (pedido, tipoCliente, index) => {
    const tipo = this.state[tipoCliente];
    tipo[index].pedidos = tipo[index].pedidos.filter(it => it !== pedido);
    this.setState({ [tipoCliente]: [...tipo] });
  }

  removeCard = (tipoCliente, index) => {
    const tipo = this.state[tipoCliente];
    tipo.splice(index, 1);
    this.setState({ [tipoCliente]: [...tipo] });
  }

  render() {
    const { facturacion, propietario, usuario } = this.state;

    return (
      <div>
        <div className='fdvAsig-slides-item simpleSlide active'>
          <div className='form-group'>
            {
              facturacion.map((f, index) => (
                <ClienteCard
                  key={index}
                  name='Cliente de facturación'
                  tipo={facturacion[index]}
                  tipoCliente='facturacion'
                  indice={index}
                  pedidos={this.props.pedidosSeleccionados}
                  selectClient={this.selectClient}
                  selectPedido={this.selectPedido}
                  unselectPedido={this.unselectPedido}
                  removeCard={this.removeCard}
                  todo={this.state.todoCard.facturacion}
                  onChangeCheck={this.onChangeCheck}
                />
              ))
            }
            {
              this.state.todoCard.facturacion === 'no' &&
                <button className='btn btn-iconLeft btn-link' onClick={() => this.addTipoCliente('facturacion')}>
                  <i className='ion-plus' />
                  <span>Agregar cliente de facturación</span>
                </button>
            }
          </div>
          
          <div className='form-group'>
            {
              usuario.map((f, index) => (
                <ClienteCard
                  key={index}
                  name='Cliente usuario'
                  tipo={usuario[index]}
                  tipoCliente='usuario'
                  indice={index}
                  pedidos={this.props.pedidosSeleccionados}
                  selectClient={this.selectClient}
                  selectPedido={this.selectPedido}
                  unselectPedido={this.unselectPedido}
                  removeCard={this.removeCard}
                  todo={this.state.todoCard.usuario}
                  onChangeCheck={this.onChangeCheck}
                />
              ))
            }
            {
              this.state.todoCard.usuario === 'no' &&
                <button className='btn btn-iconLeft btn-link' onClick={() => this.addTipoCliente('usuario')}>
                  <i className='ion-plus' />
                  <span>Agregar cliente usuario</span>
                </button>
            }
          </div>
          <div className='modal-actions'>
            <button className='btn btn-default' onClick={this.props.previousStep}>Anterior</button>
            <button className='btn btn-primary pull-right' onClick={() => this.props.nextStep('SecondStep', this.state)}>Siguiente</button>
          </div>
        </div>
      </div>
    );
  }
}

export default SecondStep;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Proformas/AsociarPedidos/SecondStep.js